import { render, staticRenderFns } from "./ModernisierteFenster.vue?vue&type=template&id=3a8145ae"
import script from "./ModernisierteFenster.vue?vue&type=script&lang=js"
export * from "./ModernisierteFenster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports